import { mui, React } from '_core';

type CheckboxFieldProps = {
  value: number;
  setValue: (_d: number) => void;
  label: string;
};

const CheckboxField = ({ value, setValue, label }: CheckboxFieldProps) => {
  const handleChange = (e: React.ChangeEvent<any>) => {
    const checked = e.target.checked;
    setValue(checked ? 1 : undefined);
  };

  return (
    <mui.core.FormControlLabel
      control={<mui.core.Checkbox onChange={handleChange} name={label} value={value} />}
      label={label}
    />
  );
};

export default CheckboxField;
